import { types } from "../types/types";

export const getFcData = (data) => ({
  type: types.getFcData,
  payload: data,
});

export const importFcData = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getFcData(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getFcDetail = (detail) => ({
  type: types.getFcDetail,
  payload: detail,
});

export const importFcDetail = (detail) => {
  return async (dispatch) => {
    try {
      dispatch(getFcDetail(detail));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getDelayedPoints = (delayedPoints) => ({
  type: types.getDelayedPoints,
  payload: delayedPoints,
});

export const importDelayedPoints = (delayedPoints) => {
  return async (dispatch) => {
    try {
      dispatch(getDelayedPoints(delayedPoints));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getSettledPoints = (settledPoints) => ({
  type: types.getSettledPoints,
  payload: settledPoints,
});

export const importSettledPoints = (settledPoints) => {
  return async (dispatch) => {
    try {
      dispatch(getSettledPoints(settledPoints));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getRegularPoints = (regularPoints) => ({
  type: types.getRegularPoints,
  payload: regularPoints,
});

export const importRegularPoints = (regularPoints) => {
  return async (dispatch) => {
    try {
      dispatch(getRegularPoints(regularPoints));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getDisplayDetail = (value) => ({
  type: types.getDisplayDetail,
  payload: value,
});

export const importDisplayDetail = (value) => {
  return async (dispatch) => {
    try {
      dispatch(getDisplayDetail(value));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getAreaName = (name) => ({
  type: types.getAreaName,
  payload: name,
});

export const importAreaName = (name) => {
  return async (dispatch) => {
    try {
      dispatch(getAreaName(name));
    } catch (error) {
      console.error(error);
    }
  };
};
